<template>

	<div class="fix">
		<div class="flex"> 
			<div class="right-fix">
				<div class="margin0">
					<div class="card">
						<div class="card-header card-header-success">
							<h4 class="card-title ">Silahkan Login</h4>
						</div>
						<div class="card-body">
							<div class="row">
								<div class="col-md-12 text-center">
									<span class="d-block">Scan QR dari Aplikasi Beatcom Network</span>
									<div class="col-md-12">
										<img v-show="qr" :src="qr" width="200px" />
										<span>
											<button class="btn btn-success btn-round" @click="getsesi()">Req Ulang QR</button>
										</span>
									</div>
								</div>
							</div>
							
							<div class="row">
								<div class="col-md-12">
								<div class="form-group">
									<label class="bmd-label-floating">Username</label>
									<input type="text" class="form-control" placeholder="Ketik Username..." v-model="username" @keyup.enter="login()">
									<small id="emailHelp" class="form-text text-danger" v-show="userStat">Username tidak boleh Kosong</small>
								</div>
								</div>
							</div>
							<div class="row">
								<div class="col-md-12">
								<div class="form-group">
									<label class="bmd-label-floating">Password</label>
									<input type="password" class="form-control" placeholder="Ketik password..." v-model="password" @keyup.enter="login()">
									<small id="emailHelp" class="form-text text-danger" v-show="passStat">Password tidak boleh Kosong</small>
								</div>
								</div>
							</div>
							<div class="row mb-2">
								<div class="col-md-12">
									<label class="bmd-label-floating">Capcha</label>
									<div class="captcha-wrap">
										<div id="CaptchaImageCode">
											<canvas ref="CapCode" class="capcode" width="300" height="80"></canvas>
										</div>
									</div>
									<input type="text" class="form-control" placeholder="Ketik Capcha..." v-model="capcha" @keyup.enter="login()">
									<small id="emailHelp" class="form-text text-danger mb-2" v-show="capStat">Capcha Salah!</small>
								</div>
							</div>
							<button type="submit" class="btn btn-success pull-right btn-round" @click="login">Login</button>
							<p class="form-text text-info" v-show="loadingText">{{resultText}}</p>
							<div class="clearfix"></div>
							<h4 class="text-center text-info mt-3">Di Akses Dari : {{ipKU}}</h4>
						</div>
						
					
						<div class="alert alert-info" role="alert" v-show="false">
							Hapus Data Browser untuk melihat updatetan fitur-fitur terbaru. Karena ini web app jadi harus Hapus data Browser untuk mendapatkan update fitur
						</div>

					</div>
				</div>
			</div>
			
			<div class="left-fix"> 
				<div class="inner-left">
					<h4 class="text-white mb-2 mt-2" v-if="loginFor == 'beatcom'">
						<span class="d-block mb-2">Download Aplikasi Owner. </span>
						<h4 class="d-block mb-2">BEATCOM NETWORK 8.1.1 ( Last Update 16 Apr 2026 ) </h4>
						<a class="text-danger d-block mb-4" href="http://download.beatcom.web.id/?app=beatcom" target="_blank">
							<img class="icon" src="@/assets/download-owner.png" alt="">
						</a>

						<!--

						<span class="d-block mb-2">Download Aplikasi Pelanggan Android. </span>
						<h4 class="d-block mb-2">MY WIFI (Last Update 07 Agustus 2024) </h4>
						<a class="text-danger d-block mb-4" href="http://download.beatcom.web.id/?app=mywifi" target="_blank">
							<img class="icon" src="@/assets/playstore.png" alt="">
						</a>
						
						-->

						<span class="d-block mb-2">Pelanggan Via Web</span>
						<a class="text-danger d-block mb-4" href="https://mywifi.beatcom.web.id/#/" target="_blank">
							<img class="icon" src="@/assets/web.png" alt="">
						</a>
						
						<span class="d-block mb-2">Untuk pelanggan Iphone </span>
						<a class="text-danger d-block mb-4" href="https://mywifi.beatcom.web.id/#/" target="_blank">
							<img class="icon" src="@/assets/iphone.png" alt="">
						</a>
					</h4>

					<h4 class="text-white mb-2 mt-2" v-else>
						<span class="d-block mb-2">Download Aplikasi Owner. </span>
						<h4 class="d-block mb-2">APLIKABEAT 7.9.0 ( Last Update 20 Feb 2026 ) </h4>
						<a class="text-danger d-block mb-4" href="http://download.beatcom.web.id/?app=aplikabeat" target="_blank">
							<img class="icon" src="@/assets/download-owner.png" alt="">
						</a>

						<!--

						<span class="d-block mb-2">Download Aplikasi Pelanggan Android. </span>
						<h4 class="d-block mb-2">MY WIFI (Last Update 07 Agustus 2024) </h4>
						<a class="text-danger d-block mb-4" href="http://download.beatcom.web.id/?app=mywifi" target="_blank">
							<img class="icon" src="@/assets/playstore.png" alt="">
						</a>
						
						-->

						<span class="d-block mb-2">Pelanggan Via Web</span>
						<a class="text-danger d-block mb-4" href="https://aplikabeat.com/#/" target="_blank">
							<img class="icon" src="@/assets/web.png" alt="">
						</a>
						
						<span class="d-block mb-2">Untuk pelanggan Iphone </span>
						<a class="text-danger d-block mb-4" href="https://aplikabeat.com/#/" target="_blank">
							<img class="icon" src="@/assets/iphone.png" alt="">
						</a>
					</h4>
					
				</div>
			</div>
		</div>
	</div>
	<!--	
	<div class="content">
		<div class="d-flex">
		</div>
        <div class="container-fluid">
        	<div class="row">
	            <div class="col-md-4 " style="margin:50px auto 0px auto;">
	              
	            </div>
			</div>
        	<div class="row">
	            <div class="col-md-4 " style="margin:50px auto 50px auto;">
				</div>
	            <div class="col-md-4 " style="margin:50px auto 50px auto;">
					<div class="alert alert-info" role="alert">
						
					</div>
				</div>
        	</div>
    	</div>
    </div> -->
</template>

<script>
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import { loginFor } from '@/var/var.js'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 

Vue.use(VueAxios, axios)

export default {
  name: 'Beranda',
	components: { 

	}, 
  	sockets: {
		verifiedqr: function(val){
			//console.log("Verified "+val);

			this.getToken();
		},
		loginqr: function(val){
			//console.log(val)
			this.qr = val;
		}
	},

	data() {
		return {
			username: '',
			password: '',
			capcha: '',
			capchaSalah: 0, // max 3
			capStat: false,
			userStat: false,
			passStat: false,
			loadingText: false,
			resultText: '',
			sesi: '',
			cap: null,
			sock: '',
			qr: null,
			ipKU: null,

			loginFor: loginFor,
			//pass: ''
		}
	},
	/*
	watch: {
		//pelanggan: 'ketik'
		username: 'userKetik',
		password: 'passKetik',
	}, */
	methods: {
		/*
		userKetik() {
			console.log(this.username)
		}, */
		
		userKetik() {

		},
		getToken() {
			var datax = {
				hash: this.sesi,
			}
		
			var apiUrl = inter.QRToken();
			
			myGlobal.call(datax,apiUrl).then(x => {
				//console.log(JSON.stringify(x));
				
				if (x.status == true) {
						sessionStorage.setItem('admin', x.data.nama);
						sessionStorage.setItem('wa', x.data.telepon);
						sessionStorage.setItem('username', x.data.username);
						sessionStorage.setItem('subAdminID', x.data.subAdminID); // jika root ini 0
						sessionStorage.setItem('subAdmin', x.data.subAdmin); // jika root ini 0
						sessionStorage.setItem('level', x.data.subAdmin);
						sessionStorage.setItem('myToken', x.data.token);

						if (x.data.tipe != null) {
							sessionStorage.setItem('tipe', x.data.tipe);
						}

						//console.log(sessionStorage.getItem('tipe'));
						//console.log(sessionStorage.getItem('subAdminID'));

						var monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni",
						"Juli", "Agustus", "September", "Oktober", "November", "Desember"
						];
						var d = new Date();

						var bulan;
							bulan = d.getMonth()+1;

						sessionStorage.setItem('tahunBase', d.getFullYear());
						sessionStorage.setItem('bulanIdBase', "0");
						sessionStorage.setItem('bulanNamaBase', monthNames[d.getMonth()]);

						location.href = '#/dashboard';

						sessionStorage.removeItem("otped"); // remove otp perusahaan
						
					} else {
						alert(x.pesan);
					}

			})
		},
		getsesi() {
			//console.log("get sesi");
			var datax = "";
			var apiUrl = 'content/sesi/get';
			this.PostData(datax,apiUrl).then(x => {

				//console.log(JSON.stringify(x));

				if (x.status == true) {
					this.sesi = x.data;
					
					// socket
					this.$socket.emit('qr-login', this.sesi);
					
					var alpha = new Array('A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'j', 'k', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '1', '2', '3', '4', '5', '6', '7', '8', '9');

					var i;
					for (i = 0; i < 6; i++) {
						var a = alpha[Math.floor(Math.random() * alpha.length)];
						var b = alpha[Math.floor(Math.random() * alpha.length)];
						var c = alpha[Math.floor(Math.random() * alpha.length)];
						var d = alpha[Math.floor(Math.random() * alpha.length)];
						var e = alpha[Math.floor(Math.random() * alpha.length)];
						var f = alpha[Math.floor(Math.random() * alpha.length)];
					}
					
					var capc = a + '' + b + '' + c + '' + d + '' + e + '' + f;
					this.cap = capc;

					var c = this.$refs.CapCode,
						ctx = c.getContext("2d"),
						x = c.width / 2,
						img = new Image();

					img.src = "http://admin.beatcom.web.id/bg-capcha.jpg";
					img.onload = function () {
						var pattern = ctx.createPattern(img, "repeat");
						ctx.fillStyle = pattern;
						ctx.fillRect(0, 0, c.width, c.height);
						ctx.font = "46px Roboto Slab";
						ctx.fillStyle = '#5a5a5a';
						ctx.textAlign = 'center';
						ctx.setTransform(1, -0.12, 0, 1, 0, 15);
						ctx.fillText(capc, x, 55);
					};

				} else {
					//alert(x.pesan);
				}
			})
		},
		login() {
			this.resultText = "Loading...";
			if (this.username == '') {
				this.userStat = true
			}
			if (this.password == '') {
				this.passStat = true
			}
			if (this.capcha == '') {
				this.capStat = true
			}
			
			if (this.capcha != this.cap) {
				this.capStat = true
				this.resultText = "Capcha Salah!";
				this.capchaSalah = this.capchaSalah + 1;
				if (this.capchaSalah < 3) {
					return false;
				} else {
					window.location.reload(); // Reloads the current page
				}
			}

			if (this.username != '' || this.password != '') {
				this.userStat = false;
				this.passStat = false;
				this.loadingText = true;

				/*
				var data = new FormData();
				data.append('pass', this.password);
				data.append('pin', this.username);
				data.append('from', "web");
				*/
				
				var salahx = localStorage.getItem("x_salah");
				if (salahx != null) {
					if (salahx > 2) { // salah 3x
						this.resultText = "Terjadi kesalahan!";
						
						//console.log(salahx);

						return false;
					}
				}

				var data = {
					pass: this.password,
					pin: this.username,
					from: "web",
					device: "Web Admin",
					deviceid: "Web Admin",
					sesi: this.sesi
				}
				
				var apiUrl = 'login';
				this.PostData(data,apiUrl).then(x => {
					
					//console.log(JSON.stringify(x));

					if (x.status == true) {
						sessionStorage.setItem('admin', x.data.nama);
						sessionStorage.setItem('wa', x.data.telepon);
						sessionStorage.setItem('username', x.data.username);
						sessionStorage.setItem('subAdminID', x.data.subAdminID); // jika root ini 0
						sessionStorage.setItem('subAdmin', x.data.subAdmin); // jika root ini 0
						sessionStorage.setItem('level', x.data.subAdmin);
						sessionStorage.setItem('myToken', x.data.token);

						if (x.data.tipe != null) {
							sessionStorage.setItem('tipe', x.data.tipe);
						}

						//console.log(sessionStorage.getItem('tipe'));
						//console.log(sessionStorage.getItem('subAdminID'));

						var monthNames = ["Januari", "Februari", "Maret", "April", "Mei", "Juni",
						"Juli", "Agustus", "September", "Oktober", "November", "Desember"
						];
						var d = new Date();

						var bulan;
							bulan = d.getMonth()+1;

						sessionStorage.setItem('tahunBase', d.getFullYear());
						sessionStorage.setItem('bulanIdBase', "0");
						sessionStorage.setItem('bulanNamaBase', monthNames[d.getMonth()]);

						location.href = '#/dashboard';

						sessionStorage.removeItem("otped"); // remove otp perusahaan
						
					} else {
						//alert(x.pesan);
						this.resultText = x.pesan;

						var salah = localStorage.getItem("x_salah");
						if (salah != null) {
							if (salah > 2) { // salah 3x
								return false;
							}
							salah = parseInt(salah) + parseInt(1);
							
							localStorage.setItem("x_salah", salah);
						} else {
							localStorage.setItem("x_salah", 1);
						}

						//console.log(salah);

					}

				})
			}

		},
		ip() {

			var apiUrl = 'ip';

			var data = {

			}

			this.PostData(data,apiUrl).then(x => {
				//console.log(JSON.stringify(x));

				if (x.status == true) {
					this.ipKU = x.data;
				} else {

				}

			})
		}
	    	//console.log(this.username)
	},
    mounted () {
		this.getsesi();

		
		this.ip();

		
		sessionStorage.setItem('walokallogin', "kosong");
		
		//this.sock = this.$socket;
		
		/*
		
							*/
	}
}

</script>
<style scoped>  
.fix {
	position: fixed;
	right: 0;
	top: 0;
	bottom: 0;
	left: 0;
	overflow: auto;
}
.flex {
	display: inherit;
	height: 100%;
}
.left-fix {
	width: 100%;
	background: linear-gradient(60deg, #66bb6a, #43a047);
    align-items: center;
	display: flex;
	padding-left: 30px;
	padding-right: 30px;
}
.right-fix {
	width: 100%;
	display: flex;
    align-items: center;
}
.icon {
	width: 170px;
}
.margin0 {
	margin: 0 auto;
	max-width: 600px;
	width: 100%;
}

.content {
	position:fixed;
	left: 0;
	width: 100%;
}

.captcha-wrap {
    position: relative;
}

#CaptchaImageCode {
    text-align: center;
    margin-top: 15px;
    padding: 0px 0;
    width: 300px;
    overflow: hidden;
}

.capcode {
    font-size: 46px;
    display: block;
    -moz-user-select: none;
    -webkit-user-select: none;
    user-select: none;
    cursor: default;
    letter-spacing: 1px;
    font-family: 'Roboto Slab', serif;
    font-weight: 100;
    font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue